import { http } from '@/lib/axios';
import { unwrap, toApiError } from '@/lib/unwrap';
import type { ApiEnvelope } from '@/types/api';

/** POST /foc-document response — the stored supporting document. */
export interface FocDocumentUpload {
  id: string;
  originalName: string;
  mimeType: string;
  sizeBytes: number;
  createdAt: string;
}

/**
 * POST /foc-document — upload the ONE supporting document (PDF / PNG / JPG,
 * max 10 MB) a free-of-charge sale must carry. The returned `id` is sent on
 * the sale (and its quote) as `focDocumentId`; the server binds it to that one
 * sale, so a document cannot back two FOC transactions.
 *
 * @throws ApiError — FOC_DOCUMENT_TOO_LARGE (413),
 *   FOC_DOCUMENT_TYPE_NOT_ALLOWED (415).
 */
export async function uploadFocDocument(file: File): Promise<FocDocumentUpload> {
  const form = new FormData();
  form.append('file', file);
  try {
    const res = await http.post<ApiEnvelope<FocDocumentUpload>>('/foc-document', form, {
      // Let the browser set the multipart boundary — override the client's JSON default.
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return unwrap(res.data);
  } catch (error) {
    throw toApiError(error);
  }
}
